// actionTypes.js
export const SET_VALUE_CONFIG_MESSAGERIE = "SET_VALUE_CONFIG_MESSAGERIE";
export const SET_STATUT_CONFIG_MESSAGERIE = "SET_STATUT_CONFIG_MESSAGERIE";
export const SET_CURRENT_PAGE_CONFIG_MESSAGERIE =
  "SET_CURRENT_PAGE_CONFIG_MESSAGERIE";
export const SET_ORDER_CONFIG_MESSAGERIE = "SET_ORDER_CONFIG_MESSAGERIE";
export const SET_SORT_FIELD_CONFIG_MESSAGERIE =
  "SET_SORT_FIELD_CONFIG_MESSAGERIE";
